import { Helmet } from 'react-helmet-async';
import { PROJECT } from '~/constants';

interface HelmetHeadProps {
  title?: string;
  description?: string;
}

export default function HelmetHead({ title, description }: HelmetHeadProps) {
  return (
    <>
      <Helmet>
        {title && (
          <>
            <title>
              {title} | {PROJECT}
            </title>
            <meta property='og:title' content={`${title} | ${PROJECT}`} />
          </>
        )}
        {description && <meta name='description' content={description} />}
      </Helmet>
    </>
  );
}
